import AWS from 'aws-sdk';
import AWSIoTData from 'aws-iot-device-sdk';

var mqttClient = null;

export const isConnected = () => (mqttClient !== null) ? true : false;

export const connect = (configuration, loggedInUserId) => {

  if (!mqttClient) {

    AWS.config.region = configuration.region;

    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: configuration.poolId,
      LoginId: loggedInUserId
    });

    console.log({
      aws_config_credentials: AWS.config.credentials,
      IdentityPoolId: configuration.poolId,
      LoginId: loggedInUserId
    })

    mqttClient = AWSIoTData.device({
      //
      // Set the AWS region we will operate in.
      //
      region: AWS.config.region,
      host: configuration.host,
      //
      // Use the clientId created earlier.
      //
      clientId: loggedInUserId + new Date().getTime().toString(),
      //
      // Connect via secure WebSocket
      //
      protocol: 'wss',
      //
      // Set the maximum reconnect time to 8 seconds; this is a browser application
      // so we don't want to leave the user waiting too long for reconnection after
      // re-connecting to the network/re-opening their laptop/etc...
      //
      maximumReconnectTimeMs: 8000,
      //
      // Enable console debugging information (optional)
      //
      debug: true,
      //
      // IMPORTANT: the AWS access key ID, secret key, and sesion token must be 
      // initialized with empty strings.
      //
      accessKeyId: '',
      secretKey: '',
      sessionToken: ''
    });

    var cognitoIdentity = new AWS.CognitoIdentity();
    AWS.config.credentials.get(function (err, data) {
      if (!err) {
        var params = {
          IdentityId: AWS.config.credentials.identityId
        };
        cognitoIdentity.getCredentialsForIdentity(params, function (err, data) {
          if (!err && mqttClient !== null) {
            //
            // Update our latest AWS credentials; the MQTT client will use these
            // during its next reconnect attempt.
            //
            console.log("cognitoIdentity")
            console.log(data)

            mqttClient.updateWebSocketCredentials(data.Credentials.AccessKeyId,
              data.Credentials.SecretKey,
              data.Credentials.SessionToken);
          } else {
            console.log('error retrieving credentials: ' + err);
          }
        });
      } else {
        console.log('error retrieving identity:' + err);
      }
    });

    mqttClient.on('connect', mqttClientConnectHandler);
    mqttClient.on('reconnect', mqttClientReconnectHandler);
    mqttClient.on('message', mqttClientMessageHandler);
  }
}

export const disconnect = () => {
  if (mqttClient) {
    mqttClient.end();
    mqttClient = null;
  }
}

const mqttClientReconnectHandler = () => {
  if (process.env.NODE_ENV !== 'production') {
    console.log("mqtt reconnect");
  }
}

const mqttClientConnectHandler = () => {
  if (process.env.NODE_ENV !== 'production') {
    console.log("mqtt connect");
  }
};

const mqttClientMessageHandler = (topic, payload) => {

  if (process.env.NODE_ENV !== 'production') {
    console.log(`${topic}: ${payload.toString()}`);
  }
  var callbacks = topicCallbackMap[topic];
  if (callbacks) {
    var data = JSON.parse(payload.toString());
    for (var i = 0; i < callbacks.length; i++) {
      callbacks[i](data);
    }
  }
};

var topicCallbackMap = {};

export const addSubscriptionTopic = (topic, callbacks) => {
  if (mqttClient) {

    if (topicCallbackMap[topic]) {
      mqttClient.unsubscribe(topic);
    }

    topicCallbackMap[topic] = Array.isArray(callbacks) ? callbacks : [callbacks];
    mqttClient.subscribe(topic);
  }
}

export const removeSubscriptionTopic = topic => {
  if (mqttClient) {
    mqttClient.unsubscribe(topic);
    delete topicCallbackMap[topic];
  }
}

export const sqsService = (stnTitle) => {
  var sqs = new AWS.SQS();
  var sqsparams = {
    MessageBody: stnTitle.replace(/[a-zA-Z]/g, ''), /* required */
    QueueUrl: 'https://sqs.ap-southeast-1.amazonaws.com/820253761273/fData_Queue',
  }
  sqs.sendMessage(sqsparams, function (err, data) {
    if (err) console.log(err, err.stack); // an error occurred
  });
}